import { graphql, useStaticQuery } from "gatsby";
import React, { useCallback, useEffect, useRef } from "react";
import Modal from "./modal";

const InfoModal = ({ show, onHide, msgKey, isChangeCompare, updateCompare }) => {
  const ref = useRef(null);
  const dialogRef = useRef(null);

  const { labelManagerLabels } = useStaticQuery(graphql`
    {
      labelManagerLabels: labelManagerLabels {
        close
        changeCompare
        changeCompareButton
        max3Productscompare
        activateGeolocation
        anErrorAsOccurred
      }
    }
  `);

  const clickBack = useCallback(
    (event) => {
      if (
        event.target !== dialogRef.current &&
        dialogRef.current &&
        !dialogRef.current.contains(event.target)
      ) {
        onHide();
      }
    },
    [onHide]
  );

  useEffect(() => {
    if (show && ref.current) {
      ref.current.focus();
    }
  }, [show]);

  const onKeyDown = useCallback(
    (e) => {
      if (e.key === "Escape") {
        onHide();
      }
    },
    [onHide]
  );

  return (
    <Modal>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions */}
      <div
        ref={ref}
        className={`cart-modal${show ? " show" : ""}`}
        // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
        tabIndex={show ? 0 : -1}
        role="dialog"
        aria-hidden={!show}
        onKeyDown={onKeyDown}
        onClick={clickBack}
      >
        <div ref={dialogRef} className="cart-modal__dialog" role="document">
          <div className="text-center">
            <div className="cart-modal__title mt-3 mt-md-4">{labelManagerLabels[msgKey]}</div>
            {isChangeCompare && (
              <button
                className="cart-modal__close mt-3 mt-md-4 mr-2"
                onClick={() => {
                  updateCompare();
                  onHide();
                }}
              >
                {labelManagerLabels.changeCompareButton}
              </button>
            )}
            <button className="cart-modal__close mt-3 mt-md-4" onClick={onHide}>
              {labelManagerLabels.close}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InfoModal;
